import React, { useState, useEffect, useMemo } from 'react';
import { useAppState } from '../../State';
import { FlowNode, FlowOption } from '../../Types/Types';
import Input from '/Foundation/Common/code/Views/Foundation/Common/Input.js';
import Select, { SelectOption } from '/Foundation/Common/code/Views/Foundation/Common/Select.jsx';
import Buttons from '../Buttons/Buttons';
import PrimaryButton from '../Buttons/PrimaryButton';

import './InputStep.less';

type InputStepProps = {
  node: FlowNode;
};

const InputStep = ({ node }: InputStepProps) => {
  const { rearMountedChildBikeSeatsData, selectOption } = useAppState();
  const cmsStep = rearMountedChildBikeSeatsData?.Steps?.find((stepData) => stepData.Parameter === node.cmsParameter);
  const translations = rearMountedChildBikeSeatsData?.Translations;

  const [width, setWidth] = useState<string>('');
  const [unit, setUnit] = useState<string>('mm');

  const selectOptions: SelectOption[] = useMemo(() => {
    return [
      { name: 'mm', value: 'mm' },
      { name: 'in', value: 'in' },
    ];
  }, []);

  useEffect(() => {
    setWidth('');
  }, [node]);

  const confirmWidth = () => {
    let option: FlowOption = {
      value: `${width} ${unit}`,
      label: node.answerKey as string,
      description: 'With of the rack',
    };
    selectOption(option);
  };

  return (
    <>
      <div className="input-step">
        <div className="input-step-content">
          {cmsStep?.ImageUrl && (
            <div className="cms-image-wrapper d-flex justify-content-center w-100 mb-9">
              <img src={cmsStep.ImageUrl} alt={cmsStep.ImageAlt} />
            </div>
          )}
          {cmsStep?.Text && <div dangerouslySetInnerHTML={{ __html: cmsStep.Text }} className="mb-5"></div>}
          <div className="d-flex flex-row">
            <Input
              id="faCbsWidthInput"
              name="faCbsWidthInput"
              type="number"
              placeholder={
                node.id === 'rackWidth' ? translations?.inputWidthPlaceholder : translations?.inputDiameterPlaceholder
              }
              value={width}
              additionalClasses="pt-5"
              min="0"
              onChange={(evt) => setWidth(evt.target.value)}
            />
            <Select
              id="faCbsUnitInput"
              name="faCbsUnitInput"
              value={unit}
              options={selectOptions}
              onChange={(evt) => setUnit(evt.target.value)}
              additionalClasses="pt-5"
              onBlur={() => {}}
              skipScroll
            />
          </div>
        </div>
      </div>
      <Buttons visible>
        <PrimaryButton visible disabled={!width} text={translations?.next ?? ''} onClick={confirmWidth} />
      </Buttons>
    </>
  );
};

export default InputStep;
